<template>
  <b-container fluid id="student-feeding" class="mt-4">
    <div class="title">
      <h6>{{ last_name }}, {{ first_name }} -- {{ school }}</h6>
    </div>
    <div id="feeding-table">
      <b-table
        v-cloak
        responsive
        :fields="fields"
        :items="getStudentFeedings"
        :striped="true"
        :bordered="true"
        :hover="true"
        stacked="md"
      ></b-table>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'StudentFeeding',
  props: {
    first_name: String,
    last_name: String,
    school: String,
  },
  data() {
    return {
      fields: [
        { key: 'feeding_date', label: 'Date', sortable: true },
        { key: 'category', label: 'Category', sortable: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getStudentFeedings: 'feedings/getStudentFeedings',
    }),
  },
  methods: {
    ...mapActions({
      GET_FEEDINGS: 'feedings/GET_FEEDING_RECORDS',
    }),
  },
  created() {
    this.GET_FEEDINGS();
  },
};
</script>
